module.exports = __webpack_public_path__ + "area_jiangzhe.fcdec296.png";